import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { Center, Group, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { CommonEndKey } from 'src/i18next';

type NavigationLinkButtonPropsType = {
  icon: FontAwesomeIconProps['icon'];
  labelKey: CommonEndKey<'NAVIGATION'>;
};

export const NavigationLinkButton: React.FC<NavigationLinkButtonPropsType> = ({
  icon,
  labelKey,
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      label={t(`NAVIGATION.${labelKey}`)}
      position="right"
      transitionProps={{ duration: 200 }}
      bg="layout.10"
      p="xs"
      offset={12}
    >
      <Group justify="center">
        <Center h={48}>
          <FontAwesomeIcon
            icon={icon}
            color="var(--mantine-color-layout-9)"
            size="sm"
            style={{ marginRight: '2px' }} // TODO: This is used to match the appearance of the old php ui, remove this once the new ui is fully implemented
          />
        </Center>
        <Text c="layout.9" hiddenFrom="sm">
          {t(`NAVIGATION.${labelKey}`)}
        </Text>
      </Group>
    </Tooltip>
  );
};
